module.exports = __webpack_public_path__ + "static/media/redwood3.496cc18a.jpg";